import ajax from '../utils/axios'

// 卖家问题件列表
export const GetSellerList = (params) => ajax.get(`/index/customer/index?limit=${params.limit}&page=${params.page}&customer_id=${params.customer_id}&order_number=${params.order_number}&status=${params.status}&problem_id=${params.problem_id}&start_cost_time=${params.start_cost_time}&end_cost_time=${params.end_cost_time}&start_create_time=${params.start_create_time}&end_create_time=${params.end_create_time}&processing_method=${params.processing_method}&shop_name=${params.shop_name}&create_uid=${params.create_uid}&claim_uid=${params.claim_uid}`)

// 转处理方案
export const PostSellerListEdit = (params) => ajax.post('/index/customer/edit', params)

// 修改店铺
export const EditShop = (params) => ajax.post('/index/customer/edit_shop', params)

// 批量结单
export const BatchCheck = (params) => ajax.post('/index/customer/batch_check', params)

// 转处理方案
export const PostChangeProcessMethod = (params) => ajax.post('/index/customer/change_process_method', params)

// 转处理方案
export const PostCustomerReverseStatus = (params) => ajax.post('/index/customer/reverse_status', params)

// 导出数据
export const PostSellerListExport = (params) => ajax.downloadFile('/index/customer/export', params)

// 获取问题列表
export const GetSellerListProblemList = (params) => ajax.get('/index/order/problem_list', params)

// 获取问题列表
export const GetSellerUserList = (params) => ajax.get('/index/user/get_firm_user_list', params)

// 获取筛选列表的下家列表
export const GetSellerListCustomerList = () => ajax.get('/index/customer/get_customers')

// 获取问题件详情
export const PostSellerListOrderDetail = (params) => ajax.post('/index/customer/order_detail', params)

// 添加留言
export const PostSellerListSendMessage = (params) => ajax.post('/index/customer/send_message', params)

// 修改附加费用
export const PostSellerListEditCost = (params) => ajax.post('/index/customer/edit_cost', params)

// 结单
export const PostSellerListFinishOrder = (params) => ajax.post('/index/customer/finish_order', params)
